export default __webpack_public_path__ + "static/media/jorgeCortes.747d2bf7.jpg";